import React from 'react';
import { Button } from './ui/button';

const AboutSection = () => {
  return (
    <section className="py-16 bg-white relative">
      {/* Red left border accent */}
      <div className="absolute left-0 top-16 bottom-16 w-1 bg-[#c94a4a]"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="lg:pl-8">
            <p className="text-[#c94a4a] font-bold text-sm uppercase tracking-wider mb-4">
              Invest. Create Jobs. Change Lives.
            </p>

            <h2 className="text-[#1a3a5c] text-4xl md:text-5xl font-bold mb-6 uppercase">
              About The
              <br />
              U.S. Visa
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              The U.S. visa program offers international investors a unique pathway to gain permanent residency in the United States, designed to stimulate economic growth through job creation and personal investment.
            </p>

            <Button
              onClick={() => document.getElementById('hero-form')?.scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              className="border-[#1a3a5c] text-[#1a3a5c] hover:bg-[#1a3a5c] hover:text-white px-8 py-3 rounded font-medium"
            >
              Tell Me More
            </Button>
          </div>

          {/* Right Image Collage */}
          <div className="relative">
            {/* Background decorative element */}
            <div className="absolute -top-8 -right-8 w-48 h-48 bg-gray-100 -z-10"></div>
            
            <div className="grid grid-cols-2 gap-1">
              {/* Top row */}
              <div className="relative h-40 overflow-hidden">
                <img
                  src="https://images.pexels.com/photos/466685/pexels-photo-466685.jpeg?auto=compress&cs=tinysrgb&w=600"
                  alt="City skyline"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-[#1a3a5c]/60 flex items-center justify-center">
                  <span className="text-white font-bold text-xl tracking-wider">INVEST</span>
                </div>
              </div>
              <div className="relative h-40 overflow-hidden">
                <img
                  src="https://images.pexels.com/photos/373912/pexels-photo-373912.jpeg?auto=compress&cs=tinysrgb&w=600"
                  alt="City buildings"
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Middle row */}
              <div className="relative h-40 overflow-hidden">
                <img
                  src="https://images.pexels.com/photos/585419/pexels-photo-585419.jpeg?auto=compress&cs=tinysrgb&w=600"
                  alt="Construction workers"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="relative h-40 overflow-hidden">
                <img
                  src="https://images.pexels.com/photos/1108101/pexels-photo-1108101.jpeg?auto=compress&cs=tinysrgb&w=600"
                  alt="Workers"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-[#1a3a5c]/60 flex items-center justify-center">
                  <span className="text-white font-bold text-xl tracking-wider">CREATE JOBS</span>
                </div>
              </div>
              
              {/* Bottom row - full width */}
              <div className="col-span-2 relative h-48 overflow-hidden">
                <img
                  src="https://images.pexels.com/photos/1128318/pexels-photo-1128318.jpeg?auto=compress&cs=tinysrgb&w=800"
                  alt="Happy family"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a3a5c]/70 to-transparent flex items-end justify-center pb-6">
                  <span className="text-white font-bold text-xl tracking-wider">CHANGE LIVES</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
